import { render, staticRenderFns } from "./ReturnPointsForm.vue?vue&type=template&id=1bf4fb22&scoped=true&"
import script from "./ReturnPointsForm.vue?vue&type=script&lang=js&"
export * from "./ReturnPointsForm.vue?vue&type=script&lang=js&"
import style0 from "./ReturnPointsForm.vue?vue&type=style&index=0&id=1bf4fb22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf4fb22",
  null
  
)

export default component.exports